import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconMenuViewBrowse, IconMenuViewClassic } from '../RestaurantMenu/MenuListingIcons';
import './MenuBrowse.css';

interface MenuViewSwitchProps {
  appName: string;
  active: 'classic' | 'browse';
  cuisineId?: number | null;
  categoryId?: number | null;
}

const MenuViewSwitch: React.FC<MenuViewSwitchProps> = ({
  appName,
  active,
  cuisineId,
  categoryId,
}) => {
  const navigate = useNavigate();

  const buildBrowseUrl = () => {
    const params = new URLSearchParams();
    if (cuisineId) params.set('cuisine', String(cuisineId));
    if (categoryId) params.set('category', String(categoryId));
    const qs = params.toString();
    return `/restaurants/${appName}/browse${qs ? `?${qs}` : ''}`;
  };

  const buildClassicUrl = () => {
    const params = new URLSearchParams();
    if (cuisineId) params.set('cuisine', String(cuisineId));
    if (categoryId) params.set('category', String(categoryId));
    const qs = params.toString();
    return `/restaurants/${appName}/menu${qs ? `?${qs}` : ''}`;
  };

  return (
    <div className="menu-view-switch" role="group" aria-label="Menu view">
      <button
        type="button"
        className={`menu-view-switch__btn${active === 'classic' ? ' menu-view-switch__btn--active' : ''}`}
        onClick={() => active !== 'classic' && navigate(buildClassicUrl())}
        aria-label="Classic menu view"
        title="Classic view"
      >
        <IconMenuViewClassic size={18} />
      </button>
      <button
        type="button"
        className={`menu-view-switch__btn${active === 'browse' ? ' menu-view-switch__btn--active' : ''}`}
        onClick={() => active !== 'browse' && navigate(buildBrowseUrl())}
        aria-label="Browse menu view"
        title="Browse view"
      >
        <IconMenuViewBrowse size={18} />
      </button>
    </div>
  );
};

export default MenuViewSwitch;
